// removed by extract-text-webpack-plugin
module.exports = {"dates-field":"src-modules-accommodation-AccommodationSchedulerView-__DatesField__dates-field--qTeId","days-of-week":"src-modules-accommodation-AccommodationSchedulerView-__DatesField__days-of-week--1noKE"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/accommodation/AccommodationSchedulerView/DatesField.less
// module id = 1872
// module chunks = 0